import React, { useEffect } from "react";

import { useForm } from "react-hook-form";

import { IPerson } from "../../models/person/Person";
import { ButtonInput } from "../Shared/Inputs/ButtonInput";
import Flyout, { FlyoutControlProps } from "../../containers/Flyout";
import { StyledTextInput } from "../Shared/StyledInputs/StyledTextInput";
import { usePeopleMutations } from "../../data/people/usePeopleMutations";

interface CreateUpdatePersonFlyoutProps extends FlyoutControlProps {
  person?: IPerson;
}

export function CreateUpdatePersonFlyout({ open, setOpen, person }: CreateUpdatePersonFlyoutProps) {
  const { create, update } = usePeopleMutations();
  const isUpdate = person !== undefined;

  const {
    register,
    handleSubmit,
    reset
  } = useForm<IPerson>({
    defaultValues: { active: true, unsubscribed: false }
  });

  const onSubmit = (data: IPerson) => {
    if (isUpdate) {
      update.mutate(data, { onSuccess: () => setOpen(false) });
    } else {
      create.mutate(data, { onSuccess: () => setOpen(false) });
    }
  }

  useEffect(() => {
    if (person) {
      reset(person);
    } else {
      reset({ active: true, unsubscribed: false });
    }
  }, [person, reset]);

  return (
    <Flyout open={open} setOpen={setOpen} title={isUpdate ? "Update Contact" : "Create Contact"}>
      <div>
        <form onSubmit={handleSubmit(onSubmit)} className="p-2 grid grid-cols-1 gap-y-2 gap-x-4 sm:grid-cols-2">
          <StyledTextInput
            label="First Name"
            register={register}
            registerName="firstName"
            registerOptions={{ required: true }}
          />
          <StyledTextInput
            label="Last Name"
            register={register}
            registerName="lastname"
            registerOptions={{ required: true }}
          />
          <div className="sm:col-span-2">
            <StyledTextInput
              label="Email"
              register={register}
              registerName="email"
              registerOptions={{ required: true }}
            />
          </div>
          <StyledTextInput
            label="Telephone 1"
            register={register}
            registerName="telephone"
          />
          <StyledTextInput
            label="Telephone 2"
            register={register}
            registerName="telephone2"
          />
          <StyledTextInput
            label="Address Line 1"
            register={register}
            registerName="addressLine1"
          />
          <StyledTextInput
            label="Address Line 2"
            register={register}
            registerName="addressLine2"
          />
          <StyledTextInput
            label="Address Line 3"
            register={register}
            registerName="addressLine3"
          />
          <StyledTextInput
            label="Address Line 4"
            register={register}
            registerName="addressLine4"
          />
          <StyledTextInput
            label="Postcode"
            register={register}
            registerName="postcode"
          />
          <div className="mt-6 sm:col-span-2">
            <ButtonInput
              isSubmit={true}
              label={isUpdate ? "Update Contact" : "Create Contact"}
              onClick={undefined}
              children={undefined}
              classes={undefined}
            />
          </div>
        </form>
      </div>
    </Flyout>
  )

}